
import React from 'react';
import { Button } from '@/components/ui/button';
import { Users, Plus } from 'lucide-react';

interface PatientEmptyStateProps {
  onAddPatient?: () => void;
}

const PatientEmptyState: React.FC<PatientEmptyStateProps> = ({ 
  onAddPatient = () => {} 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="bg-muted/50 p-4 rounded-full mb-4">
        <Users className="h-10 w-10 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold mb-2">No Patients Found</h3>
      <p className="text-muted-foreground max-w-md mb-6">
        You don't have any patients that match your current filters or search criteria.
      </p>
      <Button onClick={onAddPatient}>
        <Plus className="h-4 w-4 mr-2" />
        Add New Patient
      </Button>
    </div>
  );
};

export default PatientEmptyState;
